import {
  INTROSPECTION_QUERY,
  GET_SEASONS_TEAMS_GAMES_PLAYERS,
  GET_SEASONS_TEAMS_PLAYERS,
  GET_SEASONS_TEAMS_GAMES,
  GET_TEAM_SEASON_WITH_GAMES_PLAYERS,
  GET_TEAM_SEASON_WITH_GAMES,
  GET_TEAM_SEASON_WITH_PLAYERS,
  GET_SEASON_GAMES_PLAYERS,
  GET_SEASON_GAMES,
  GET_SEASON_PLAYERS,
  GET_SEASONS_TEAMS,
} from '@tagboard/tgb-gql-helpers';
import { apolloClient } from './apollo-client';
import PusherService from './pusher';

export default {
  async getSchema() {
    try {
      const {
        data,
        error,
        // loading, NOTE: this is available if needed
      } = await apolloClient.query({
        fetchPolicy: 'network-only',
        query: INTROSPECTION_QUERY,
      });

      if (error) {
        throw new Error(error);
      }

      return data;
    } catch (error) {
      console.error('Error fetching sportradar schema:', error);
      return {};
    }
  },

  async getStatSelectionData({
    leagueName,
    seasonId,
    teamId,
    playerId,
    gameId,
    ownerId,
    statPeriod,
    statType,
  }) {
    const isPlayerGameStats = statType === 'player' && statPeriod === 'game';
    const isPlayerSeasonStats = statType === 'player' && statPeriod === 'season';
    const isTeamGameStats = statType === 'team' && statPeriod === 'game';

    let query;

    if (isPlayerGameStats) {
      query = GET_SEASONS_TEAMS_GAMES_PLAYERS;
    } else if (isTeamGameStats) {
      query = GET_SEASONS_TEAMS_GAMES;
    } else if (isPlayerSeasonStats) {
      query = GET_SEASONS_TEAMS_PLAYERS;
    } else {
      // if controls are not provided, we will default to get all the things since this is new
      query = GET_SEASONS_TEAMS_GAMES_PLAYERS;
    }

    const { data } = await apolloClient.query({
      query,
      variables: { leagueName, seasonId, teamId, playerId, gameId },
      fetchPolicy: 'network-only',
      context: {
        headers: {
          'tgb-owner-id': ownerId,
        },
      },
    });

    return data.getGraphicsConnectModal;
  },

  async statSelectorTeamChange({
    leagueName, ownerId, seasonId, teamId, statPeriod, statType,
  }) {
    const isPlayerGameStats = statType === 'player' && statPeriod === 'game';
    const isPlayerSeasonStats = statType === 'player' && statPeriod === 'season';
    const isTeamGameStats = statType === 'team' && statPeriod === 'game';

    let query;
    if (isPlayerGameStats) {
      query = GET_TEAM_SEASON_WITH_GAMES_PLAYERS;
    } else if (isTeamGameStats) {
      query = GET_TEAM_SEASON_WITH_GAMES;
    } else if (isPlayerSeasonStats) {
      query = GET_TEAM_SEASON_WITH_PLAYERS;
    } else {
      query = GET_SEASONS_TEAMS;
    }

    const { data } = await apolloClient.query({
      query,
      variables: { leagueName, seasonId, teamId },
      fetchPolicy: 'network-only',
      context: {
        headers: { 'tgb-owner-id': ownerId },
      },
    });

    return data.getGraphicsConnectModal;
  },

  async statSelectorSeasonChange({
    leagueName, ownerId, seasonId, teamId, statPeriod, statType, playerId,
  }) {
    const isPlayerGameStats = statType === 'player' && statPeriod === 'game';
    const isPlayerSeasonStats = statType === 'player' && statPeriod === 'season';
    const isTeamGameStats = statType === 'team' && statPeriod === 'game';
    const isTeamSeasonStats = statType === 'team' && statPeriod === 'season';

    let query;

    if (isPlayerGameStats) {
      query = GET_SEASON_GAMES_PLAYERS;
    } else if (isTeamGameStats) {
      query = GET_SEASON_GAMES;
    } else if (isPlayerSeasonStats) {
      query = GET_SEASON_PLAYERS;
    } else if (isTeamSeasonStats) {
      query = GET_SEASONS_TEAMS;
    }

    const { data } = await apolloClient.query({
      query,
      variables: { leagueName, seasonId, teamId, playerId },
      fetchPolicy: 'network-only',
      context: {
        headers: { 'tgb-owner-id': ownerId },
      },
    });

    return data.getGraphicsConnectModal;
  },

  gameChannelId(sport, gameId) {
    return `sportradar_game_${sport?.toLowerCase()}_${gameId}`;
  },

  subscribeToGameChannel(sport, gameId) {
    if (!sport || !gameId) {
      console.error(`subscribeToGameChannel - sport and gameId is required. Values provided: ${sport} and ${gameId}`); // eslint-disable-line no-console
      return null;
    }

    const pusher = PusherService.getClientInstance();
    const channelId = this.gameChannelId(sport, gameId);
    return pusher.subscribe(channelId);
  },

  unsubscribeFromGameChannel(sport, gameId) {
    if (!sport || !gameId) {
      return;
    }

    const pusher = PusherService.getClientInstance();
    const channelId = this.gameChannelId(sport, gameId);
    pusher.unsubscribe(channelId);
  },
};
